import React, { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Divider,
  Link,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Stack
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { createUser, signInWithGoogle, authErrorMessage } from "../firebase";
import AuthLayout from "./AuthLayout";
import AddressField from "./AddressField";
import GoogleButton from "./GoogleButton";

const Register = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [point, setPoint] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const register = async () => {
    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await createUser(email.trim(), password, displayName.trim(), phone, point);
      // La app pide verificar el email antes de continuar
      navigate("/home");
    } catch (err) {
      setError(authErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = async () => {
    setError("");
    setGoogleLoading(true);
    try {
      const user = await signInWithGoogle();
      if (user) navigate("/home");
    } catch (err) {
      setError(authErrorMessage(err));
    } finally {
      setGoogleLoading(false);
    }
  };

  return (
    <AuthLayout title="Crear una cuenta" subtitle="Sumate para publicar y consultar vehículos">
      <Stack spacing={2} sx={{ mt: 3, mb: 1 }}>
        <GoogleButton onClick={handleGoogle} loading={googleLoading}>
          Registrarse con Google
        </GoogleButton>
        <Divider sx={{ color: "text.secondary", fontSize: 13 }}>o con tu email</Divider>
      </Stack>
      {error && (
        <Alert severity="error" sx={{ my: 2, width: '100%' }}>
          {error}
        </Alert>
      )}

      <Box component="form" onSubmit={(e) => { e.preventDefault(); register(); }} sx={{ width: '100%', mt: 1 }}>
        <Stack spacing={2}>
          <TextField
            label="Nombre de Cliente"
            fullWidth
            required
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
          />
          <TextField
            label="Correo Electrónico"
            type="email"
            fullWidth
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Número de Teléfono"
            fullWidth
            required
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <div>
            <AddressField
              label="Dirección"
              name="point"
              required
              stacked
              value={point}
              onChange={(e) => setPoint(e.target.value)}
            />
          </div>
          <TextField
            label="Contraseña"
            variant="outlined"
            type={showPassword ? "text" : "password"}
            autoComplete="new-password"
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Repetir Contraseña"
            type="password"
            fullWidth
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            size="large"
            fullWidth
            disabled={loading}
          >
            {loading ? "Creando cuenta..." : "Registrarse"}
          </Button>
        </Stack>
      </Box>

      <Typography variant="body2" sx={{ mt: 3, textAlign: "center" }}>
        ¿Ya tenés cuenta?{" "}
        <Link component={RouterLink} to="/login" sx={{ fontWeight: 600 }}>
          Iniciar sesión
        </Link>
      </Typography>
    </AuthLayout>
  );
};

export default Register;